module.exports = __webpack_public_path__ + "img/nature (1).15a7c58f.svg";